var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"two",attrs:{"squared":"","to":{ name: 'informeprograma' }}},[_vm._v("Informe programas")]),_c('b-button',{staticClass:"one",attrs:{"squared":""}},[_vm._v("Informe Preliminar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }